import React, { useEffect, useState } from "react";
import { Auth } from "aws-amplify";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { singupValidationSchema } from "../../../Utility/Validations";
import { createRecordTB, saveUserInTenantGroup, updateTenantFn } from "../../../Utility/ApiService";
// import { sendHubspotEmail } from "../../../graphql/queries";
// import envFile from "../../../Utility/envFile";
import { useNavigate } from "react-router-dom";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";
import moment from "moment";
import randomstring from "randomstring";
import { getId } from "../../../Utility";

function SignUp({ tenant, setLoading, setHideAuth, redirectToLogin }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(singupValidationSchema),
  });
  const [showConfirmCode, setShowConfirmCode] = useState(false);
  const navigate = useNavigate();
  const [enterPwdSignUpToggle, setEnterSignUpPwdToggle] = useState(false);
  const [re_enterPwdToggle, setRe_enterPwdToggle] = useState(false);
  const [isVerifiedCaptcha, setIsVerifiedCaptcha] = useState(false);

  useEffect(() => {
    setHideAuth(showConfirmCode);
  }, [showConfirmCode]);

  useEffect(() => {
    if (tenant) {
      setValue("first_name", tenant?.first_name);
      setValue("last_name", tenant?.last_name);
      setValue("email", tenant?.email);
    }
  }, [tenant]);

  useEffect(() => {
    if (errors?.password?.type === "matches") {
      toast.error(errors?.password?.message);
    }
  }, [errors]);

  const formSignUp = async (data) => {
    try {
      if (!tenant?.first_name && !tenant?.last_name && !tenant?.id) {
        toast.error("Oops! - Only Invited Tenants are able to sign up or sign in to this portal.");
        return;
      }
      setLoading(true);
      const data1 = await Auth.signUp({
        username: data.email,
        password: data.password,
        attributes: {
          email: data.email,
        },
        validationData: [],
      });

      await Auth.signIn(data.email, data.password);

      let obj = {
        id: tenant.id,
        email: data.email,
        first_name: data.first_name,
        last_name: data.last_name,
        cognito_user_id: data1.userSub,
        email_verification_uuid: randomstring.generate(20),
        email_verification: 1,
        active: 1,
        last_modified: moment().format("YYYY-MM-DD HH:mm:ss"),
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      };

      await updateTenantFn(obj);

      // await API.graphql(
      //   graphqlOperation(sendHubspotEmail, {
      //     id: tenant?.id,
      //     role: "Tenant",
      //     code: "EMAILVERIFY",
      //     data: JSON.stringify({
      //       name: `${data.first_name} ${data.last_name}`,
      //       url: `${envFile.SIGNUP_URL}Verification/${obj?.cognito_user_id}~${obj?.email_verification_uuid}`,
      //     }),
      //   })
      // );
      await createRecordTB("UserNotification", {
        id: getId(),
        user_id: tenant.created_by,
        notification_type: "Tenant Invitation",
        title: "Tenant Invitation",
        message: `${obj.first_name + " " + obj.last_name} has registered their account on the Tenant Portal`,
        active: 1,
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
        last_modified: moment().format("YYYY-MM-DD HH:mm:ss"),
      });

      await saveUserInTenantGroup(data1.userSub, data1.user.pool.userPoolId);
      navigate("/Dashboard");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
      toast.error(
        'A user with this email already exists. Try signing in or select "Forgot Password" at sign in to reset.' ||
          error.message ||
          "Something went wrong"
      );
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit(formSignUp)}>
        {/*
        <div className={"mb-3 " + (errors.first_name && "error")}>
          <label htmlFor="first_name" className="form-label">
            First Name<span className="required-label">*</span>
          </label>
          <input {...register("first_name")} type="text" className="form-control" placeholder="Enter First Name" />
          <p>{errors.first_name?.message}</p>
        </div>

        <div className={"mb-3 " + (errors.last_name && "error")}>
          <label htmlFor="last_name" className="form-label">
            Last Name<span className="required-label">*</span>
          </label>
          <input {...register("last_name")} type="text" className="form-control" placeholder="Enter Last Name" />
          <p>{errors.last_name?.message}</p>
        </div>
      */}
        <div className={"mb-3 " + (errors.email && "error")}>
          <label htmlFor="email" className="form-label">
            Email<span className="required-label">*</span>
          </label>
          <input {...register("email")} type="email" className="form-control" placeholder="Enter Email" />
          <p>{errors.email?.message}</p>
        </div>

        <div className={"mb-3 " + (errors.password && "error")}>
          <label htmlFor="password" className="form-label">
            Create Password
            <span className="required-label">*</span>
          </label>
          <div className="field-group">
            <input
              className="form-control input-password"
              type={enterPwdSignUpToggle ? "text" : "password"}
              placeholder="Enter your password"
              {...register("password")}
            />
            <span
              onClick={() => {
                setEnterSignUpPwdToggle(!enterPwdSignUpToggle);
              }}
              toggle="#password"
              className={enterPwdSignUpToggle ? "fa fa-eye toggle-password" : "fa fa-eye-slash toggle-password"}
            />
            <p>{errors.password?.type === "required" && errors.password?.message}</p>
          </div>
        </div>

        <div className={"mb-3 " + (errors.confirmPassword && "error")}>
          <label htmlFor="reenter-password" className="form-label">
            Renter Password
            <span className="required-label">*</span>
          </label>
          <div className="field-group">
            <input
              className="form-control input-password"
              type={re_enterPwdToggle ? "text" : "password"}
              placeholder="Renter your password"
              {...register("confirmPassword")}
            />
            <span
              onClick={() => {
                setRe_enterPwdToggle(!re_enterPwdToggle);
              }}
              toggle="#reenter-password"
              className={re_enterPwdToggle ? "fa fa-eye toggle-password" : "fa fa-eye-slash toggle-password"}
            />
            <p>{errors.confirmPassword?.message}</p>
          </div>
        </div>
        <div className="mb-3">
          <GoogleReCaptcha
            onVerify={(token) => {
              if (token) setIsVerifiedCaptcha(true);
            }}
          />
        </div>
        <div className={"mb-4 form-check " + (errors.isValid && "error")}>
          <input type="checkbox" className="form-check-input" {...register("isValid")} />
          <label className="form-check-label" htmlFor="terms">
            I agree to Arrivo's{" "}
            <a href="/TermsAndCondition" target="_blank">
              Terms of Use{" "}
            </a>
            &amp;{" "}
            <a href="/PrivacyPolicy" target="_blank">
              Privacy Policy
            </a>
            , as well as the Terms of Use (
            <a href="https://www.dwolla.com/legal/tos/" target="_blank">
              Dwolla
            </a>
            ,{" "}
            <a href="https://www.payabli.com/documents-payabli-terms-of-use/" target="_blank">
              Payabli
            </a>
            ) and Privacy Policy (
            <a href="https://www.dwolla.com/legal/privacy/#legal-content" target="_blank">
              Dwolla
            </a>
            ,{" "}
            <a href="https://www.payabli.com/documents-payabli-privacy-policy/" target="_blank">
              Payabli
            </a>
            ) of our partners.
          </label>
          <p>{errors.isValid?.message}</p>
        </div>
        <button type="submit" className="btn btn-primary w-100" disabled={!isVerifiedCaptcha}>
          Sign Up
        </button>
      </form>
    </div>
  );
}

export default SignUp;
